// AUTO-GENERATED by scripts/gen-build-info.js — do not edit.
export const BUILD_INFO = { sha: '91619fe9', builtAt: '2026-10-20 16:53 UTC' };
